import { useCallback } from "react";

import { API_BASE_URL } from "@/api/api.config";
import useRestMutation from "@/remoteState/useRestMutation";

const usePollSubmissionPost = () => {
  const pollSubmission = useCallback((payload) => {
    return new Request(`${API_BASE_URL}/api/v3/activity/interaction/`, {
      method: "POST",
      body: JSON.stringify(payload),
      headers: { "Content-Type": "application/json" },
    });
  }, []);

  return useRestMutation(pollSubmission);
};

export default usePollSubmissionPost;
